// extracted by extract-css-chunks-webpack-plugin
module.exports = {"paymentPayoutOverview":"_2thn4I","tables":"_1RXar6","spinnerHolder":"_3ByhKE","errMsg":"_1wkz7z","modal":"_3r2sMa","open":"_2XkV_c"};